import UUID from '../../../utils/uuid';
import Storage from '../../../storage/index';
import Config from '../../../config/index';

function updateByApiStackIn(params: StackInParams): Promise<void> {
    let actionId: string = new UUID().id;
    let paperId: number = Config.get({
        moduleName: 'base',
        key: 'paperId'
    });
    let dataList: HistoryItem[] = createItemList(params, `action-${actionId}`, paperId);

    return Storage.addGroup('history', dataList);
}

function createItemList(params: StackInParams, actionId: string, paperId: number): HistoryItem[] {
    let result: HistoryItem[] = [];

    params.data.forEach((updateInfo: UpdateTask): void => {
        result.push({
            actionId,
            paperId,
            type: 'updateByApi',
            data: [updateInfo],
            extendParams: params.extendParams || {}
        });
    });

    return result;
}

export {
    updateByApiStackIn
};
